import { render, staticRenderFns } from "./CompSocial.vue?vue&type=template&id=a8664792&scoped=true"
import script from "./CompSocial.vue?vue&type=script&lang=js"
export * from "./CompSocial.vue?vue&type=script&lang=js"
import style0 from "./CompSocial.vue?vue&type=style&index=0&id=a8664792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8664792",
  null
  
)

export default component.exports